import React, { useContext, useEffect, useState } from 'react'
import { Button, Form, Icon, Modal } from 'semantic-ui-react'
import { useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { history } from '../../redux/store'
import {
  GetUserTemplates,
  CreateTemplate,
} from '../../services/configuration-template'
import StatusDialog from '../status-dialog'
import { RefreshCustomerDeviceList } from '../../redux/actions/devices'
import IntelMsg from '../ItelMsg'
import { AssetViewContext } from '../assets/asset-info-view/assetView'

export default function ConfigurationModal() {
  const [templatesList, setTemplateList] = useState([])
  const { register, errors, handleSubmit, clearErrors } = useForm()
  const [showDialog, setShowDialog] = useState(false)
  const [disableSubmit] = useState(false)
  const [statusDialogContent, setStatusDialogContent] = useState('')
  const customer = localStorage.getItem('customer')
  const { openTemplateDialog, setOpenTemplateDialog, assetData } =
    useContext(AssetViewContext)
  console.log('assetCustomerData', customer)
  console.log('assetData', assetData)
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const productName = localStorage.getItem('product')

  useEffect(() => {
    if (customer && assetData) {
      GetUserTemplates(productName, customer, assetData['asset type']).then(
        (data) => {
          console.log('templates', data)
          setTemplateList(data)
        },
      )
    }
  }, [assetData])
  async function onSubmit(data) {
    clearErrors()
    CreateTemplate(
      productName,
      assetData,
      customer,
      data.templateName,
      'assign',
    ).then((response) => {
      setOpenTemplateDialog(false)
      dispatch(RefreshCustomerDeviceList(true))
      if (!response.success) {
        setStatusDialogContent(response.msg)
        setShowDialog(true)
      }
    })
  }
  const handleClose = () => setOpenTemplateDialog(false)

  // useEffect(() => {
  //   setCustomerId(assetCustomerData)
  //   console.log('assetType', assetData['asset type'])
  //   GetUserTemplates(productName, customerId, assetData['asset type']).then(
  //     (list) => {
  //       console.log('list', list)
  //       setTemplateList(list)
  //     },
  //   )
  // }, [])

  return (
    <>
      <Modal
        onClose={() => setOpenTemplateDialog(false)}
        onOpen={() => setOpenTemplateDialog(true)}
        open={openTemplateDialog}
        size="tiny"
        style={{ position: 'relative', height: 'auto' }}
      >
        <Modal.Header style={{ background: '#1678c2', color: 'white' }}>
          <IntelMsg id="selectConfigurationTemplate" />
        </Modal.Header>
        <Modal.Content scrolling>
          <Form
            id="assignTemplate"
            onSubmit={handleSubmit(onSubmit)}
            widths="equal"
          >
            <Form.Group>
              <Form.Field>
                <label htmlFor="templateName">
                  <IntelMsg id="chooseYourTemplate" />
                </label>
                <select
                  ref={register({
                    validate: { isValidSelect: (value) => value !== '-1' },
                  })}
                  name="templateName"
                >
                  <option value={-1}>{t('selectTemplate')}</option>
                  {templatesList
                    ? templatesList.map((item) => (
                        <option
                          value={item['template name']}
                          key={item['template name']}
                        >
                          {item['template name']}
                        </option>
                      ))
                    : null}
                </select>
                <small style={{ color: 'red' }}>
                  {errors.templateName &&
                  errors.templateName.type === 'isValidSelect'
                    ? 'Required'
                    : '**'}
                </small>
              </Form.Field>
            </Form.Group>
          </Form>
          <Button
            content="Create new template"
            labelPosition="right"
            icon="add"
            style={{ background: '#303D54' }}
            onClick={() => {
              setOpenTemplateDialog(false)
              console.log('assetDataaa', assetData)
              // item['asset type']
              history.push({
                pathname: '/template',
                search: `?assetID=${assetData['asset id']}&assetName=${assetData['asset name']}&assetType=${assetData['asset type']}&assetLabel=${assetData['asset label']}`,
              })
            }}
            // &assetName=${assetData['asset type']}
            positive
          />
        </Modal.Content>
        <Modal.Actions>
          <Button
            type="submit"
            form="assignTemplate"
            color="blue"
            disabled={disableSubmit}
          >
            <IntelMsg id="submit" />
          </Button>
          <Button
            // className={modalStyles.negativeStatus}
            style={{ background: '#303D54', color: 'white' }}
            onClick={() => {
              handleClose()
            }}
          >
            <IntelMsg id="closeBtn" />
          </Button>
        </Modal.Actions>
      </Modal>
      <StatusDialog
        showDialog={showDialog}
        setShowDialog={setShowDialog}
        dialogHeader="Device Configuration Issue"
        dialogContent={
          <>
            <Icon name="exclamation triangle" size="huge" color="red" />
            <p style={{ fontSize: 'x-large' }}>{statusDialogContent}</p>
          </>
        }
      />
    </>
  )
}
